import Footer from "app/pages/.shared/Footer/Footer";

export default props => <Footer {...props} showReassurance={false} />;
